import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'

import { user } from './user'
import { warranties } from './warranties'
import { message } from './message'
import { contests } from './contests'
import { coupons } from './coupons'

export const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['user', 'message'],
}

export const rootReducer = combineReducers({
  user,
  warranties,
  message,
  contests,
  coupons,
})

export type AppState = ReturnType<typeof rootReducer>
